export const CustomLegend = ({ payload }: any) => {
  if (!payload) return null;

  return (
    <div className="flex items-center gap-4 px-1">
      {payload.map((entry: any, index: number) => (
        <div key={index} className="flex items-center gap-1.5">
          <div
            className="w-2 h-2 rounded-full"
            style={{
              backgroundColor: entry.color || "#bce3ff",
            }}
          />
          <span className="text-[13px] text-gray-500 capitalize">
            {entry.value}
          </span>
        </div>
      ))}
    </div>
  );
};
